const printTypeLangs = {
  printTypeList: {
    title: "Danh sách kiểu in",
  },
  printTypeDetail: {
    title: "Chi tiết kiểu in: {{name}}",
  },
  printTypeAdd: {
    title: "Thêm kiểu in",
  },
  error: {
    printTypeList: "lấy danh sách kiểu in lỗi",
  },
};

export default printTypeLangs;
